import { ApiResponse } from '@models/common/api';
import {
  IGetScoreAndSuggestionsResponse,
  IGetScoreAndSuggestionsRequest,
  ISpartacusCreateOrganizationResponse,
  ISpartacusCreateOnboardingApiResponse,
  ISpartacusCreateOnboardingRequest,
  ISpartacusCreateOnboardingResponse,
  ICreateSpecializationResponse,
  ICreateSpecializationRequest,
  IFindAllSpecializationResponse,
  ISignWithGoogleResponse,
  ISpartacusCreateOrganizationRequest,
  ISpartacusCreateOrganizationApiResponse,
  ISpartacusCreateBrandApiResponse,
  ISpartacusCreateBrandRequest,
  ISpartacusCreateBrandResponse,
  ISpartacusSaveAccountRequest,
  ICreateSpecializationApiResponse,
} from '@models/spartacus/onboarding';
import * as ListingReviewClient from '@webidoo-eng/jooice-listing-review';

import { get, post } from '../methods';

const BASE_ENDPOINT = 'spartacus/onboarding';

const spartacusOnboardingAPI = {
  // ONBOARDING SPARTACUS V2
  createOrganization: async (
    body: ISpartacusCreateOrganizationRequest,
  ): Promise<ISpartacusCreateOrganizationResponse> => {
    const response = await post<ISpartacusCreateOrganizationApiResponse>(`${BASE_ENDPOINT}/organization`, body);
    return response.data.data;
  },
  createBrand: async (
    organizationId: number,
    body: ISpartacusCreateBrandRequest,
  ): Promise<ISpartacusCreateBrandResponse> => {
    const response = await post<ISpartacusCreateBrandApiResponse>(`${BASE_ENDPOINT}/brand`, body, {
      params: { organizationId },
    });
    return response.data.data;
  },
  saveAccountInfo: (body: ISpartacusSaveAccountRequest): void => {
    post(`${BASE_ENDPOINT}/save-account-info`, body);
  },
  createSpecialization: async (
    organizationId: number,
    body: ICreateSpecializationRequest,
  ): Promise<ICreateSpecializationResponse> => {
    const response = await post<ICreateSpecializationApiResponse>(`${BASE_ENDPOINT}/specialization`, body, {
      params: { organizationId },
    });
    return response.data.data;
  },
  tagUser: async (): Promise<'REVIEW' | 'SOCIAL'> => {
    const response = await post<ApiResponse<{ spartacusFlow: 'REVIEW' | 'SOCIAL' }>>(`${BASE_ENDPOINT}/flow`, {});
    return response.data.data.spartacusFlow;
  },
  // ONBOARDING SPARTACUS V1
  create: async (body: ISpartacusCreateOnboardingRequest): Promise<ISpartacusCreateOnboardingResponse> => {
    const response = await post<ISpartacusCreateOnboardingApiResponse>(`${BASE_ENDPOINT}`, body);
    if (response.data?.data) return response.data.data;

    // Fallback for environments where legacy endpoint is not available
    const organization = await spartacusOnboardingAPI.createOrganization({ businessName: body.businessName ?? '' });
    const brand = await spartacusOnboardingAPI.createBrand(organization.organizationId, {
      businessName: body.businessName ?? '',
    });
    return {
      organizationId: organization.organizationId,
      brandId: brand.brandId,
      gmbConnectionUrl: null,
    };
  },
  tagUserSpartacus: async (): Promise<'REVIEW' | 'SOCIAL'> => {
    return spartacusOnboardingAPI.tagUser();
  },
  getScoreAndSuggestions: async (data: IGetScoreAndSuggestionsRequest): Promise<IGetScoreAndSuggestionsResponse> => {
    const response = await get<IGetScoreAndSuggestionsResponse>(`${BASE_ENDPOINT}/score-and-suggestions`, {
      params: data,
    });
    return response.data;
  },
  marketingStep: async (body: unknown) => {
    const client = ListingReviewClient as unknown as {
      onboardingControllerBusinessStep: (args: { body: unknown }) => Promise<{ data: unknown }>;
    };
    const response = await client.onboardingControllerBusinessStep({ body });
    return response.data;
  },
  marketingStepOld: async (body: unknown) => {
    const response = await post<unknown>(`${BASE_ENDPOINT}/business-step`, body);
    return response.data;
  },
  findAllSpecialization: async (organizationId: number): Promise<IFindAllSpecializationResponse> => {
    const response = await get<IFindAllSpecializationResponse>(`${BASE_ENDPOINT}/specialization`, {
      params: { organizationId },
    });
    return response.data;
  },
  signWithGoogle: async (payload: { token: string }): Promise<ISignWithGoogleResponse> => {
    const response = await post<ApiResponse<ISignWithGoogleResponse>>(`${BASE_ENDPOINT}/sign-with-google`, payload);
    return response.data.data;
  },
};

export default spartacusOnboardingAPI;
